import { render } from "./Marital_Status.vue?vue&type=template&id=0e0c8117"
import script from "./Marital_Status.vue?vue&type=script&lang=js"
export * from "./Marital_Status.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__